import { render, staticRenderFns } from "./BfixDash.vue?vue&type=template&id=3d28821e&scoped=true"
import script from "./BfixDash.vue?vue&type=script&lang=ts"
export * from "./BfixDash.vue?vue&type=script&lang=ts"
import style0 from "./BfixDash.scss?vue&type=style&index=0&id=3d28821e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28821e",
  null
  
)

export default component.exports